/**
 * @flow
 * @relayHash 2fce5d1441d2ca43f02f81d2fcc0e900
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TopicSelector_viewer$ref = any;
export type MediaFileStateType = "available" | "deleted" | "%future added value";
export type MediaFileTypeEnum = "image" | "live" | "video" | "wallpaper" | "%future added value";
export type PopupMeta_item_QueryVariables = {|
  id: string
|};
export type PopupMeta_item_QueryResponse = {|
  +node: ?{|
    +id?: string,
    +title?: ?string,
    +slug?: ?string,
    +description?: ?string,
    +filename?: ?string,
    +alt?: ?string,
    +type?: MediaFileTypeEnum,
    +preview?: ?string,
    +authors?: ?$ReadOnlyArray<?string>,
    +show?: ?string,
    +topics?: ?$ReadOnlyArray<?{|
      +id: string,
      +name: ?string,
    |}>,
    +status?: ?string,
    +seoKeywords?: ?string,
    +seoDescription?: ?string,
    +seoTitle?: ?string,
    +state?: MediaFileStateType,
  |},
  +viewer: ?{|
    +$fragmentRefs: TopicSelector_viewer$ref
  |},
|};
export type PopupMeta_item_Query = {|
  variables: PopupMeta_item_QueryVariables,
  response: PopupMeta_item_QueryResponse,
|};
*/


/*
query PopupMeta_item_Query(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ... on MediaFile {
      id
      title
      slug
      description
      filename
      alt
      type
      preview
      authors
      show
      topics {
        id
        name
      }
      status
      seoKeywords
      seoDescription
      seoTitle
      state
    }
    id
  }
  viewer {
    ...TopicSelector_viewer
    id
  }
}

fragment TopicSelector_viewer on Viewer {
  topicsForSelector: topics(first: -1) {
    edges {
      node {
        id
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "filename",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "alt",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "preview",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "authors",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "show",
  "args": null,
  "storageKey": null
},
v12 = [
  v2,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }
],
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topics",
  "storageKey": null,
  "args": null,
  "concreteType": "Topic",
  "plural": true,
  "selections": v12
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "seoKeywords",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "seoDescription",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "seoTitle",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "PopupMeta_item_Query",
  "id": null,
  "text": "query PopupMeta_item_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on MediaFile {\n      id\n      title\n      slug\n      description\n      filename\n      alt\n      type\n      preview\n      authors\n      show\n      topics {\n        id\n        name\n      }\n      status\n      seoKeywords\n      seoDescription\n      seoTitle\n      state\n    }\n    id\n  }\n  viewer {\n    ...TopicSelector_viewer\n    id\n  }\n}\n\nfragment TopicSelector_viewer on Viewer {\n  topicsForSelector: topics(first: -1) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "PopupMeta_item_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "type": "MediaFile",
            "selections": [
              v2,
              v3,
              v4,
              v5,
              v6,
              v7,
              v8,
              v9,
              v10,
              v11,
              v13,
              v14,
              v15,
              v16,
              v17,
              v18
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "TopicSelector_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PopupMeta_item_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          },
          v2,
          {
            "kind": "InlineFragment",
            "type": "MediaFile",
            "selections": [
              v3,
              v4,
              v5,
              v6,
              v7,
              v8,
              v9,
              v10,
              v11,
              v13,
              v14,
              v15,
              v16,
              v17,
              v18
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "topicsForSelector",
            "name": "topics",
            "storageKey": "topics(first:-1)",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": -1,
                "type": "Int"
              }
            ],
            "concreteType": "TopicConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TopicEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Topic",
                    "plural": false,
                    "selections": v12
                  }
                ]
              }
            ]
          },
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '560db280d891a1b9cca360575dd7faad';
module.exports = node;



// WEBPACK FOOTER //
// src/components/media/__generated__/PopupMeta_item_Query.graphql.js